import { render, staticRenderFns } from "./DataProjects.vue?vue&type=template&id=fabcd712"
import script from "./DataProjects.vue?vue&type=script&lang=js"
export * from "./DataProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports